module.exports = __webpack_public_path__ + "47f89d23a6f3bb2e224ce786d784785a.pdf";